import { appendVueRoute, Role, type RoutePath } from '@therame/shared';
import { type RouteRecordRaw } from 'vue-router';
import { type RestrictedRecordRaw } from '..';

const routes: Array<RouteRecordRaw> = [
  {
    ...appendVueRoute<'patientAccountList'>('patientAccountList', '/patient/account-list'),
    // Workspace catch-all (PRD #971 / RS-007): serializes the open patient
    // cascade into the URL (PRD #963). Empty cascade is the base path;
    // deeper paths like `/patient/account-list/patientFile:<id>` are columns.
    path: '/patient/account-list/:cascade(.*)?' as RoutePath<'patientAccountList'>,
    component: () => import('@src/views/PatientAccountList.vue'),
    meta: {
      layout: 'default',
      title: 'Patient:innen',
      requiresAuth: true,
      requiresOnboarding: true,
      noPadding: true,
      accessPossibleWithRoles: [Role.ADMIN, Role.THERAPIST, Role.MANAGEMENT],
      // accessPossibleWithPayedFeatures: [PayedFeatureType.THERAME],
      workspace: true,
      officeLocationScoped: true,
    },
  },
] satisfies RestrictedRecordRaw[];

export default routes;
